// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uWan","col":"styles_col__3vo-C"};